<template>
  <div class="neibu_shiyong">
    <div v-if="!pupopShow" style="width: 95%; margin: auto">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            style="display: flex"
            class="t_search_form"
            label-position="left"
            label-width="90px"
            :model="form"
          >
            <el-form-item label="使用出库编号:" label-width="100px">
              <el-input v-model="form.syckdh" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="化学品:" label-width="90px">
              <el-input v-model="form.hxpmc" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="退回日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="form.beginTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  :picker-options="startTime"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="form.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  :picker-options="endTime"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="50px">
              <el-select
                v-model="form.zt"
                style="width: 100%"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in statuslist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-button
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              class="chongzhiButton"
              size="small"
              icon="el-icon-refresh-right"
              round
              @click="reset"
            >重置</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <div class="tablemes">
          <el-table
            ref="cktable"
            :data="tableData"
            border
            :cell-style="cellStyle"
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
            :header-cell-class-name="cellClass"
            @selection-change="handleSelectionChange"
            @select-all="checkSelect"
          >
            <el-table-column>
              <template slot="header">
                <el-button
                  v-preventReClick
                  type="primary"
                  class="addButton"
                  size="mini"
                  icon="el-icon-plus"
                  style="border: none"
                  @click="addPupShow"
                >新增</el-button>
                <!-- <el-button
                  size="mini"
                  icon="el-icon-plus"
                  v-preventReClick
                  @click="addEditMes"
                  >复制新增</el-button
                > -->
                <el-button
                  v-preventReClick
                  icon="el-icon-upload2"
                  size="mini"
                  @click="dcexcel"
                >导出</el-button>
              </template>
              <el-table-column
                align="center"
                type="selection"
                width="55"
              />

              <el-table-column
                v-for="(item, i) in table"
                :key="i"
                :show-overflow-tooltip="true"
                align="center"
                :label="item.label"
                :width="
                  item.key == 'thckmc'
                    ? '180'
                    : item.key == 'syckdh'
                      ? '200'
                      : ''
                "
                :prop="item.key == 'thrq' ? 'thrq' : ''"
              >
                <template slot-scope="scope">
                  <span
                    v-if="item.key != 'bgcs' || scope.row[item.key] == 0"
                    :title="scope.row[item.key]"
                  >
                    {{
                      item.key == "thsl" && scope.row["thsldwmc"] != null
                        ? scope.row[item.key] +
                          "  (" +
                          scope.row["thsldwmc"] +
                          ")"
                        : scope.row[item.key]
                    }}
                  </span>
                  <span
                    v-else
                    v-preventReClick
                    style="cursor: pointer"
                    @click="bgcsClick(scope.row)"
                  >{{ scope.row.bgcs }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-document"
                    size="mini"
                    @click="handleSelect(scope.row.id, scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="handleEdit(scope.row.id)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    class="deleteButton"
                    icon="el-icon-delete"
                    size="mini"
                    @click="handleDelete(scope.row.id)"
                  >删除</el-button>
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    :type="scope.row.zt == '11' ? 'info' : 'warning'"
                    :disabled="scope.row.zt == '11'"
                    icon="el-icon-edit"
                    size="mini"
                    @click="bgfunc(scope.row.id, scope.row)"
                  >变更</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <neibu-pup
      v-if="pupopShow"
      ref="dialognbsy"
      :leixing="leixing"
      :nbsy="type"
      :djsjdisable="djsjdisable"
      :bgdisable="bgdisable"
      :row-id="rowId"
      :cur-row-objnbsy="curRowObjnbsy"
    />
  </div>
</template>
<script>
import {
  getNbstMes,
  deletenbsyDetailMes,
  getnbsyztMes,
  exportnbsyMes
} from '@/assets/js/common.js'
import NeibuPup from './neibuPup.vue'
import bgcs from '@/components/bgcs'
export default {
  components: { NeibuPup, bgcs },
  props: {},
  data() {
    return {
      bgcs_cur: null,
      curRowObjnbsy: {},
      bgcsTKName: '内部使用退回',
      startTime: {
        disabledDate: (time) => {
          if (this.form.endTime) {
            return time.getTime() > new Date(this.form.endTime).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.form.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.form.beginTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      bgwindow: false,
      // 登记时间是否展示
      djsjdisable: false,
      // 变更是否展示
      bgdisable: false,
      form: {
        syckdh: '',
        hxpmc: '',
        beginTime: '',
        endTime: '',
        zt: ''
      },
      pupopShow: false,
      searchForm: {},
      table: [
        {
          key: 'syckdh',
          label: '使用出库编号'
        },
        {
          key: 'hxpmc',
          label: '化学品名称'
        },
        {
          key: 'thckmc',
          label: '返回仓库名称'
        },
        {
          key: 'thrq',
          label: '退回日期'
        },
        {
          key: 'thsl',
          label: '退回量'
        },
        {
          key: 'bgcs',
          label: '变更次数'
        },
        {
          key: 'ztmc',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      multipleSelection: [],
      leixing: '',
      type: true,
      statuslist: [],
      rowId: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    getnbsyztMes().then((e) => {
      this.statuslist = e.data.data
    })
    this.search()
  },
  beforeDestroy() {},
  methods: {
    // 点击变更次数
    bgcsClick(curRow) {
      // this.curRowObj = curRow;
      this.$bus.emit('bgcsOpen', curRow, '21')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 变更
    bgfunc(rowId, row) {
      this.djsjdisable = true
      this.bgdisable = true
      this.pupopShow = true
      this.type = false
      this.curRowObjnbsy = row
      this.rowId = rowId
      this.leixing = 'bg'
    },
    // 新增
    addPupShow() {
      this.pupopShow = true
      this.leixing = 'add'
      this.type = false
      this.djsjdisable = false
      this.bgdisable = false
    },
    // 点击复制新增
    addEditMes() {
      // 只有选中为一行才可新增
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: 'info',
          message: '请选择一条数据'
        })
        return
      }
      this.rowId = this.multipleSelection[0].id
      this.djsjdisable = false
      this.bgdisable = false
      this.type = false
      this.leixing = 'copy'
      this.pupopShow = true
    },
    // 查看
    handleSelect(rowId, row) {
      this.pupopShow = true
      this.leixing = 'ck'
      this.rowId = rowId
      this.type = true
      this.djsjdisable = true
      this.bgdisable = false
      this.curRowObjnbsy = row
      this.$bus.emit('fatherToChil', row, '21')
    },
    // 编辑
    handleEdit(rowId) {
      this.pupopShow = true
      this.type = false
      this.leixing = 'edit'
      this.rowId = rowId
      this.djsjdisable = true
      this.bgdisable = false
    },
    // 点击导出按钮
    dcexcel() {
      exportnbsyMes({
        syckdh: this.form.syckdh,
        hxpmc: this.form.hxpmc,
        beginTime: this.form.beginTime,
        endTime: this.form.endTime,
        zt: this.form.zt
      }).then((e) => {
        const table = '内部使用退回'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 删除行数据
    handleDelete(rowId) {
      this.$confirm('确认是否删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletenbsyDetailMes(rowId).then((e) => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.search()
        })
      })
    },
    reset() {
      this.pagesize = 10
      this.currentPage = 1
      this.form = {
        syckdh: '',
        hxpmc: '',
        beginTime: '',
        endTime: '',
        zt: ''
      }
      this.search()
    },
    search() {
      this.getNbstMess({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          syckdh: this.form.syckdh,
          hxpmc: this.form.hxpmc,
          beginTime: this.form.beginTime,
          endTime: this.form.endTime,
          zt: this.form.zt
        }
      })
    },
    // 获取表信息
    getNbstMess(dataObj) {
      getNbstMes(dataObj).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.cktable.clearSelection()
        this.$refs.cktable.toggleRowSelection(val.pop())
      }
    },
    checkSelect(selection) {
      this.$refs.cktable.clearSelection()
    },
    // 取消全选框
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disableheadselection'
      }
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 7) {
        switch (row.zt) {
          case '01':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '11':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '00':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    }
  }
}
</script>
<style scoped lang='less'>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/.el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 32px;
  width: 30px !important;
  color: #303133;
}
.neibu_shiyong {
  // height: 100%;
  .headerSearch {
    max-width: 1518px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        // width: 90px;
        // height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
</style>
